import gql from 'graphql-tag';

export const INTLLoyaltyTransactionFragmentLegacy = gql`
  fragment INTLLoyaltyTransactionFragmentLegacy on INTLLoyaltyTransaction {
    shortId
    status
    loyaltyId
    channel
    pointsEarned
    bonusPointsEarned
    pointsUsed
    createdAt
    total
    currency
    rbiOrderId
    rewardIds
    pointsDeducted
    additionalReferenceIds {
      id
      type
    }
    transactionDetails {
      promotions {
        id
        metadata {
          agentEmail
          comments
          createdAt
          externalIdentifiers {
            value
            type
          }
          maxTransactionLimitReached
          name
          orderId
          remediationReason
          source
        }
        type
      }
    }
  }
`;

export const INTLLoyaltyTransactionFragmentForTimeline = gql`
  fragment INTLLoyaltyTransactionFragmentForTimeline on INTLLoyaltyTransaction {
    additionalReferenceIds {
      id
      type
    }
    id
    channel
    createdAt
    currency
    metadata {
      agentEmail
      comments
      remediationReason
      identifierType
    }
    transactionDetails {
      person {
        currentLoyaltyTier {
          loyaltyTierExpiryDate
          loyaltyTierKey
          pointsEarnedInTimeConstraint
          startAt
        }
        currentPoints
      }
    }
    pointsDeducted
    pointsEarned
    bonusPointsEarned
    pointsUsed
    rbiOrderId
    shortId
    storeId
    store {
      timezone
      storeAddress {
        country
      }
    }
    total
  }
`;

export const INTLLoyaltyTransactionFragmentForSingleOrder = gql`
  fragment INTLLoyaltyTransactionFragmentForSingleOrder on INTLLoyaltyTransaction {
    additionalReferenceIds {
      id
      type
    }
    status
    transactionDetails {
      promotions {
        id
        metadata {
          name
        }
      }
    }
    metadata {
      maxTransactionLimitReached
    }
    rbiOrderId
  }
`;

export const INTLLoyaltyTransactionFragmentForDetailView = gql`
  fragment INTLLoyaltyTransactionFragmentForDetailView on INTLLoyaltyTransaction {
    shortId
    status
    loyaltyId
    channel
    pointsEarned
    bonusPointsEarned
    pointsUsed
    createdAt
    total
    currency
    rbiOrderId
    rewardIds
    pointsDeducted
    additionalReferenceIds {
      id
      type
    }
    storeId
    store {
      storeAddress {
        address1
        address2
        city
        stateProvince
        country
      }
      timezone
    }
    metadata {
      agentEmail
      identifierType
    }
    transactionDetails {
      person {
        currentPoints
      }
      payments {
        type
        amount
      }
      orders {
        lineId
        parentReferenceId
        plu
        productId
        price
        quantity
        pluDocuments {
          name
        }
      }
      promotions {
        id
        metadata {
          name
        }
      }
      fulfillment {
        type
      }
      posVendor {
        type
      }
    }
  }
`;
